import {useCallback} from 'react';
import {UseSendProps} from '../../../hooks/sendHooks.types';
import {prepareParameterValuesForSave} from '../../../component/whatsAppTemplateEditor/hooks/useTemplateStructure';

export const useSend = ({whatsappData, emailData, smsData, show, sendFunction, data}: UseSendProps) => {

    const handleSend = useCallback(async (type: string, trialRecipients?: string[]) => {
        const prepared = whatsappData.whatsappTemplate ? prepareParameterValuesForSave(whatsappData.whatsappTemplate) : [];
        const messageData = {
            whatsapp: {
                ...whatsappData,
                parameterValues: prepared,
            },
            email: emailData,
            sms: smsData,
        };
        try {
            await sendFunction(type, {
                ...messageData[type], 
                ...(trialRecipients ? {trialRecipients} : {}),
                ...data
            });
            return true;
    
        } catch (error) {
            console.error('Failed to send leads:', error);
            show.close();
            return false;
        }
    }, [whatsappData, emailData, smsData]);

    return {handleSend};
};
